
import { googleMapsKey, mapStyles } from '../constants';

export default async dealerMap => { // 'comp-dealer > [map]'
	const 	{default: MapsLoader} = await import('load-google-maps-api'),
			Maps = await MapsLoader({
				v: '3.30',
				key: googleMapsKey,
				libraries: ['places']
			}),
			geo = new Maps.Geocoder();
	let addr = dealerMap.getAttribute('map'),
		marker;				
	geo.geocode( { 'address': addr}, (results, status) => {
		if (status == Maps.GeocoderStatus.OK) {
			marker = new Maps.Marker({
				position:results[0].geometry.location,
				animation: Maps.Animation.DROP,
				draggable: false,
				clickable: false,
				map: new Maps.Map(dealerMap, Object.assign({
					center: results[0].geometry.location
				},{ 
					zoom: 8,
					// mapTypeControl: false,
					// streetViewControl: false,
					scrollwheel: false,
					draggable: false,
					disableDefaultUI: true,
					disableDoubleClickZoom: true,
					styles: mapStyles
				})),
				icon: {
					url: '/images/map-pin.png',
					size: new Maps.Size(42, 68),
					origin: new Maps.Point(0, 0),
					anchor: new Maps.Point(21, 68),
					scaledSize: new Maps.Size(42, 68)
				}
			});
		} else {
			console.info("Geocode was not successful for the following reason: " + status);
		}
	});
};